exports.registerSuccesMessage = "Félicitations! Votre compte a été créé avec succès, vous pouvez désormais utiliser vos identifiants pour vous connecter."
exports.makeOrderMessage = "Félicitations! Votre commande a été enregistrée";
exports.resetMessage = 'Vérifiez votre adresse email';
exports.resetPasswordMessage = "Félicitations! Vous pouvez désormais vous connecter"
exports.contactUsSendMessage = 'Message envoyé!';
exports.succesLoginMessage = 'Félicitations! Identification réussie';
exports.updatePasswordMessage = 'Félicitations! Votre mot de passe a été actualisé';
exports.updateAdresseMessage = 'Votre adresse a été actualisée';
exports.updateInfoMessage = 'Informations modifiées avec succès';